export default "__VITE_ASSET__C63ra0XS__"